// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3gLaY","col":"styles_col__3_UVZ"};